import * as AppPics from 'assets/images';
import { AppButton } from 'components';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import MCQ from './MCQ';
import FillInTheBlanks from './FillInTheBlanks';
import useSource from '../useSource';
import ShortAnswer from './ShortAnswer';
import MatchTheFollowing from './MatchTheFollowing';
import DetailsHeader from 'components/molecules/DetailsHeader';
import SubQuestions from './SubQuestions';
import { Link, useParams } from 'react-router-dom/cjs/react-router-dom';
import useQueryParams, { QueryParamsAsString } from 'hooks/useQueryParams';
import useChapters from 'hooks/API/GET/useChapters';
import Select from 'react-select';

const respectiveTabs = {
  screen_mock_test: { value: 'screen_mock', key: 'mock_test', apiVersion: 1 },
  screen_previous_year: { value: 'screen_previous_year', key: 'previous_year', apiVersion: 1 },
  screen_question_bank: { value: 'screen_qb', key: 'question_bank', apiVersion: 1 },
  screen_ncert_solutions: { value: 'screen_ncert', key: 'ncert_solutions', apiVersion: 1 },
  screen_past_papers: { value: 'screen_past_papers', key: 'past_papers', apiVersion: 1 },
};

function Main({ editMode }) {
  const { classID, courseID, chapterID, quizID } = useParams();
  const queryParams = useQueryParams();

  const queryString = QueryParamsAsString();

  const paperId = queryParams.get('paperId');
  const __screen = queryParams.get('screen');
  const __navFrom = queryParams.get('tab');
  // ['choice', 'fill', 'match', 'short', 'subQuestions']
  const [qPicker, setQPicker] = useState('choice');
  // ['single', 'multiple']
  const [category, setCategory] = useState('single');
  const [showOptions, setShowOptions] = useState(false);
  const [showForm, toggleShowForm] = useState(false);

  const { manageQuizQuestion, quizQuestion } = useSource({ paperId });
  const { isLoading, mutate } = manageQuizQuestion;
  const { data, isLoading: fetching, isFetching } = quizQuestion;

  const __tab = respectiveTabs[__screen];
  const __fromPerform = __navFrom === 'perform';
  // consider if this is really reqquired or an alternative can be provided
  const { data: chapterData } = useChapters({
    enabled: !!__tab?.value,
    courseID,
    classID,
    configs: { params: { screen: __tab?.value, apiVersion: 1 } },
  });
  const { result = [] } = chapterData?.data ?? {};
  let currentChapter = __fromPerform ? result[0] : result?.find((item) => item._id === chapterID);

  let __isUnderTeacherReview = false;
  if (__tab?.key && !__fromPerform) {
    __isUnderTeacherReview =
      currentChapter?.quizzes[__tab?.key]?.find((item) => item?._id === quizID)?.['status'] ===
      'teacher_review';
  }
  if (__tab?.key && __fromPerform) {
    __isUnderTeacherReview =
      currentChapter?.quizzes[__tab?.key]?.find((item) => item?._id === quizID)?.[
        'reviewStatusOfQuiz'
      ] === 'teacher_review';
  }

  useEffect(() => {
    if (data?.data) {
      if (data?.data?.questionType) setQPicker(data.data.questionType);
      if (data?.data?.category) setCategory(data.data.category);
    }
  }, [data?.data]);

  function handleQuizQuestion(quizFormData = {}) {
    if (isLoading) return;

    if (data?.data?._id) {
      quizFormData.id = data?.data?._id;
    } else if (paperId) quizFormData.paperId = paperId;

    mutate(quizFormData, {
      onSuccess() {
        setQPicker('choice');
        setShowOptions(false);
        toggleShowForm(!showForm);
      },
    });
  }

  return (
    <div className="mainWraper">
      <div className="tab">
        {/* START: TABS */}
        <ul className="tab__menu">
          <li className="back">
            <Back />
          </li>
          <li className="active">Questions</li>
          {/* <li>NCERT Answered</li>
          <li>Previous Year Questions</li> */}
        </ul>
        {/* END: TABS */}

        <div className="tab__content p-0">
          {/* START: 1 */}
          <div className="tab__content-actHead">
            <DetailsHeader
              fromAssess={!(__navFrom === 'perform')}
              fromPerform={__navFrom === 'perform'}
            />
          </div>
          {/* END: 1 */}

          {/* START: BODY */}
          <div className="tab__content-actBody">
            {false ? (
              'Loading...'
            ) : (
              <div className="px-5">
                {!editMode && !showForm && (
                  <>
                    <div className="w-50 p-3">
                      {!__isUnderTeacherReview && (
                        <AppButton
                          variantClass="btn-plane g--tint"
                          onClick={(e) => {
                            setShowOptions(!showOptions);
                          }}
                        >
                          + New Question
                        </AppButton>
                      )}
                      {/* <AppButton
                        variantClass="btn-plane green"
                        onClick={() => toggleShowForm(true)}
                      >
                        Next
                      </AppButton> */}
                      <Link
                        to={`/classes/${classID}/courses/${courseID}/chapters/${chapterID}/quizzes/${quizID}/questions${queryString}`}
                      >
                        <AppButton variantClass="btn-plane green mx-2">List Questions</AppButton>
                      </Link>
                    </div>
                    {showOptions && (
                      <>
                        {/* Multiple Choice */}
                        <div className="w-50 p-3">
                          <div className="d-flex align-items-center">
                            <span className="radioBlock">
                              <input
                                id="choice"
                                name="choice"
                                value="choice"
                                type="radio"
                                checked={qPicker === 'choice'}
                                onChange={() => setQPicker('choice')}
                              />
                              <label htmlFor="choice">Multiple Choice Question having</label>
                            </span>
                          </div>
                          <div className="w-75 p-3">
                            <Select
                              styles={{
                                control: (baseStyles) => ({
                                  ...baseStyles,
                                  borderColor: '#e9baf0',
                                  'box-shadow': '0 0.8rem 1.2rem rgba(20, 102, 204, 0.14)',
                                }),
                              }}
                              isClearable={false}
                              isSearchable={false}
                              className="basic-single"
                              classNamePrefix="select"
                              name="mcqOptionsDq"
                              options={mcqOptions}
                              value={mcqOptions.find?.((x) => x.value === category)}
                              onChange={(args) => {
                                setCategory(args.value);
                              }}
                            />
                            {/* <select
                              required
                              value={category}
                              onChange={(event) => setCategory(event.target.value)}
                            >
                              <option value="single">Only One Correct Answer</option>
                              <option value="multiple">More than One Correct Answer</option>
                            </select> */}
                          </div>
                        </div>
                        {/* Multiple Choice */}

                        {/* Fill In the Blanks */}
                        <div className="w-50 p-3">
                          <div className="d-flex align-items-center">
                            <span className="radioBlock">
                              <input
                                id="fillInTheBlanks"
                                name="fill"
                                value="fill"
                                type="radio"
                                checked={qPicker === 'fill'}
                                onChange={() => setQPicker('fill')}
                              />
                              <label htmlFor="fillInTheBlanks">Fill In the Blanks Question</label>
                            </span>
                          </div>
                        </div>
                        {/* Fill In the Blanks */}

                        {/* Match the Following */}
                        <div className="w-50 p-3">
                          <div className="d-flex align-items-center">
                            <span className="radioBlock">
                              <input
                                id="matchTheFollowing"
                                name="match"
                                value="match"
                                type="radio"
                                checked={qPicker === 'match'}
                                onChange={() => setQPicker('match')}
                              />
                              <label htmlFor="matchTheFollowing">
                                Match the Following Question
                              </label>
                            </span>
                          </div>
                        </div>
                        {/* Match the Following */}

                        {/* Short Answer Question */}
                        <div className="w-50 p-3">
                          <div className="d-flex align-items-center">
                            <span className="radioBlock">
                              <input
                                id="shortAnswer"
                                name="short"
                                value="short"
                                type="radio"
                                checked={qPicker === 'short'}
                                onChange={() => setQPicker('short')}
                              />
                              <label htmlFor="shortAnswer">Short Answer Question</label>
                            </span>
                          </div>
                        </div>
                        {/* Short Answer Question */}

                        {/* Sub Questions */}
                        <div className="w-50 p-3">
                          <div className="d-flex align-items-center">
                            <span className="radioBlock">
                              <input
                                id="subQuestions"
                                name="subQuestions"
                                value="subQuestions"
                                type="radio"
                                checked={qPicker === 'subQuestions'}
                                onChange={() => setQPicker('subQuestions')}
                              />
                              <label htmlFor="subQuestions">Sub Questions</label>
                            </span>
                          </div>
                        </div>
                        {/* Sub Questions */}
                      </>
                    )}
                  </>
                )}
                {isFetching || fetching ? (
                  'Loading...'
                ) : (
                  <>
                    {(editMode || showForm) && qPicker === 'choice' && (
                      <MCQ
                        data={data}
                        editMode={editMode}
                        handleSave={handleQuizQuestion}
                        toggleView={[showForm, toggleShowForm]}
                        selectedCategory={[category, setCategory]}
                      />
                    )}
                    {(editMode || showForm) && qPicker === 'fill' && (
                      <FillInTheBlanks
                        data={data}
                        editMode={editMode}
                        handleSave={handleQuizQuestion}
                        toggleView={[showForm, toggleShowForm]}
                        selectedCategory={[category, setCategory]}
                      />
                    )}
                    {(editMode || showForm) && qPicker === 'match' && (
                      <MatchTheFollowing
                        data={data}
                        editMode={editMode}
                        handleSave={handleQuizQuestion}
                        toggleView={[showForm, toggleShowForm]}
                        selectedCategory={[category, setCategory]}
                      />
                    )}
                    {(editMode || showForm) && qPicker === 'short' && (
                      <ShortAnswer
                        data={data}
                        editMode={editMode}
                        handleSave={handleQuizQuestion}
                        toggleView={[showForm, toggleShowForm]}
                        selectedCategory={[category, setCategory]}
                      />
                    )}
                    {(editMode || showForm) && qPicker === 'subQuestions' && (
                      <SubQuestions
                        data={data}
                        editMode={editMode}
                        handleSave={handleQuizQuestion}
                        toggleView={[showForm, toggleShowForm]}
                        selectedCategory={[category, setCategory]}
                      />
                    )}
                  </>
                )}
              </div>
            )}
          </div>
          {/* END: BODY */}

          {!editMode && !showForm && showOptions && (
            <div className="mb-5 btnTab-foot mt-5">
              <AppButton variantClass="btn-plane green" onClick={() => toggleShowForm(true)}>
                Next
              </AppButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export const mcqOptions = [
  { label: 'Only One Correct Answer', value: 'single' },
  { label: 'More than One Correct Answer', value: 'multiple' },
];

function Back() {
  const history = useHistory();

  return (
    <AppButton variantClass="btn-back" onClick={history.goBack}>
      <img src={AppPics.BackSvg} alt="click to go back" />
    </AppButton>
  );
}

export default Main;
